
import React, { useEffect, useState, memo } from 'react'
import { Link, useParams } from 'react-router-dom'
import { createSelector } from 'reselect'
import { useSelector, useDispatch } from 'react-redux'
import {
  Grid,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Button,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Snackbar,
} from '@mui/material'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { Row, Col, Collapse, Checkbox, Layout, Input, Space } from 'antd'

import { Alert } from '@material-ui/lab'
import CurrencyFormat from 'react-currency-format'

//API
import {
  getLastReservationDetails,
  getCodeDiscount,
  validationCoupon,
  getAllCoupons,
} from '../../services/FirebaseServices/reservationServices'

//HELPERS
import {
  formatDates,
  formatDateToDB,
  isEmailValid,
  isEmailValidGifted,
  isEmpty,
  isEmptyGifted,
  isEmptyLastName,
  isEmptyLastNameGifted,
} from '../../utils/helpers'
import { getAgencyById } from '../../services/FirebaseServices/agencyServices'

//ASSETS

//REDUX
import {
  makeSelectStartDate,
  makeSelectEndDate,
  makeSelectGuestAmount,
  makeSelectSingleDate,
  makeSelectTime,
  makeSelectChildAmount,
  makeSelectTotalPrice,
  makeSelectHotelHour,
  makeSelectPartialPrice,
  makeSelectService,
  makeSelectAddonsPrice,
  makeSelectSelectedAddons,
  makeSelectAddonsPersonsPrice,
  makeSelectReservationPrice,
  makeSelectCode,
  makeSelectGiftCard,
  set_code,
  set_total_price,
  set_single_date,
  makeSelectExitDate,
  makeSelectExitTime,
  makeSelectExtraPersons,
} from '../../redux/ducks/reservationDetails'

import {
  makeSelectName,
  makeSelectLastName,
  makeSelectPhone,
  makeSelectEmail,
  makeSelectGiftedName,
  makeSelectGiftedLastName,
  makeSelectGiftedPhone,
  makeSelectGiftedEmail,
} from '../../redux/ducks/reservationInfo'

import {
  makeSelectTermsAndConditions,
  set_terms_and_conditions,
} from '../../redux/ducks/verifyReservation'

import {
  makeSelectSingleExperience,
  makeSelectAgency,
} from '../../redux/ducks/experiences'

import {
  makeSelectTotalOrderPrice,
  makeSelectOrderProducts,
  makeSelectDeliveryAddress,
  makeSelectOrderIndications,
  makeSelectDispatchMethod,
} from '../../redux/ducks/restaurantMenu'

import moment from 'moment'
import axios from 'axios'

import { getExperienceById } from '../../services/FirebaseServices/experienceServices'
import PayPalModule from '../PaymentModules/PayPalModule'
import WebPayModule from '../PaymentModules/WebPayModule'
import FlowModule from '../PaymentModules/FlowModule'
import DifPay from '../PaymentModules/DifPay'
import { width } from '@mui/system'

const stateSelector = createSelector(
  [
    makeSelectStartDate,
    makeSelectExitDate,
    makeSelectExitTime,
    makeSelectExtraPersons,

    makeSelectEndDate,
    makeSelectGuestAmount,
    makeSelectName,
    makeSelectLastName,
    makeSelectPhone,
    makeSelectEmail,
    makeSelectTermsAndConditions,
    makeSelectSingleExperience,
    makeSelectSingleDate,
    makeSelectTime,
    makeSelectChildAmount,
    makeSelectTotalPrice,
    makeSelectHotelHour,
    makeSelectAgency,
    makeSelectPartialPrice,
    makeSelectTotalOrderPrice,
    makeSelectOrderProducts,
    makeSelectDeliveryAddress,
    makeSelectOrderIndications,
    makeSelectDispatchMethod,
    makeSelectService,
    makeSelectAddonsPrice,
    makeSelectSelectedAddons,
    makeSelectAddonsPersonsPrice,
    makeSelectReservationPrice,
    makeSelectCode,
    makeSelectGiftedName,
    makeSelectGiftedLastName,
    makeSelectGiftedPhone,
    makeSelectGiftedEmail,
    makeSelectGiftCard,
  ],
  (
    startDate,
    exitDate,
    exitTime,
    extraPersons,
    endDate,
    guestAmount,
    name,
    lastName,
    phone,
    email,
    termsAndConditions,
    singleExperience,
    singleDate,
    time,
    childAmount,
    totalPrice,
    hotelHour,
    agency,
    partialPrice,
    totalOrderPrice,
    orderProducts,
    deliveryAddress,
    orderIndications,
    dispatchMethod,
    service,
    addonsPrice,
    selectedAddons,
    addonsPersonsPrice,
    reservationPrice,
    code,
    giftedName,
    giftedLastName,
    giftedPhone,
    giftedEmail,
    giftCard,
  ) => ({
    startDate,
    exitDate,
    exitTime,
    extraPersons,

    endDate,
    guestAmount,
    name,
    lastName,
    phone,
    email,
    termsAndConditions,
    singleExperience,
    singleDate,
    time,
    childAmount,
    totalPrice,
    hotelHour,
    agency,
    partialPrice,
    totalOrderPrice,
    orderProducts,
    deliveryAddress,
    orderIndications,
    dispatchMethod,
    service,
    addonsPrice,
    selectedAddons,
    addonsPersonsPrice,
    reservationPrice,
    code,
    giftedName,
    giftedLastName,
    giftedPhone,
    giftedEmail,
    giftCard,
  }),
)

const actionDispatch = (dispatch) => ({
  setTermsAndConditions: (termsAndConditions) =>
    dispatch(set_terms_and_conditions(termsAndConditions)),
  setCode: (code) => dispatch(set_code(code)),
  setTotalPrice: (totalPrice) => dispatch(set_total_price(totalPrice)),
  setSingleDate: (singleDate) => dispatch(set_single_date(singleDate)),
})

const VerifyDetails = ({
  handleBack,
  type,
  hotDeal,
  isErrorName,
  isErrorLastName,
  isErrorEmail,
  isErrorGiftedName,
  isErrorGiftedLastName,
  isErrorGiftedEmail,
}) => {
  const { agencyId, reservationId, couponId } = useParams()

  const {
    startDate,
    exitDate,
    exitTime,
    extraPersons,

    endDate,
    guestAmount,
    name,
    lastName,
    phone,
    email,
    termsAndConditions,
    singleExperience,
    singleDate,
    time,
    childAmount,
    totalPrice,
    agency,
    partialPrice,
    totalOrderPrice,
    deliveryAddress,
    dispatchMethod,
    addonsPrice,
    addonsPersonsPrice,
    reservationPrice,
    code,
    giftedName,
    giftedLastName,
    giftedPhone,
    giftedEmail,
    giftCard,
  } = useSelector(stateSelector)

  const { setTermsAndConditions, setCode, setSingleDate } = actionDispatch(
    useDispatch(),
  )

  const [termsAccepted, setTermsAccepted] = useState(false)
  const [dataToCode, setDataToCode] = useState([])
  const [isCharged, setIsCharged] = useState(0)
  const [detailDiscount, setDetailDiscount] = useState({ discount: 0 })
  const [isError, setIsError] = useState(false)
  const [isErrorDay, setIsErrorDay] = useState(false)
  const [isExpirationCode, setIsExpirationCode] = useState(false)
  const [isDiscountApplied, setIsDiscountApplied] = useState(false)
  const [currencyExchanged, setCurrencyExchanged] = useState(0)
  const [experienceResponse, setExperienceResponse] = useState('')
  const [clpToUsd, setClpToUsd] = useState(0)
  const [experienceId, setExperienceId] = useState(singleExperience.key)
  const [paypalClient, setPaypalClient] = useState('')
  const [discountCode, setDiscountCode] = useState('')
  const [apliedCode, setApliedCode] = useState(false)
  const [validData, setValidData] = useState(false)
  const [openSnackBarCodes, setOpenSnackBarCodes] = useState(false)

  const [alertTermsAndConditions, setAlertTermsAndConditions] = useState(false)
  const [openSnackBarTerms, setOpenSnackBarTerms] = useState(false)

  let filterTimeout

  let dateDealDif
  let formatDateDif
  if (
    hotDeal &&
    singleExperience.isPartialCharge &&
    singleExperience.partialPercentage === 0
  ) {
    const partsDate = hotDeal.day.split('-')
    const dateDeal = new Date(
      parseInt(partsDate[0]), // Año
      parseInt(partsDate[1]) - 1, // Mes (restamos 1 porque en JavaScript los meses van de 0 a 11)
      parseInt(partsDate[2]), // Día
    )

    const day = dateDeal.getDate()
    const month = dateDeal.getMonth() + 1 // Sumar 1 al mes
    const year = dateDeal.getFullYear()

    dateDealDif = dateDeal
    const formatDate = `${day < 10 ? '0' : ''}${day}/${month < 10 ? '0' : ''
      }${month}/${year}`
    formatDateDif = formatDate
  }

  useEffect(() => {
    const fetchData = async () => {
      const discount = await getAllCoupons(agencyId)
      setDiscountCode(discount)
    }

    fetchData()
    getAgency()
  }, [])

  const validPayMentDates = () => {
    if (!name || !lastName || !phone || !email) {
      setValidData(false)

      return false
    }
    setValidData(true)
    return true
  }

  const fetchReservationData = async () => {
    const reservation = await getLastReservationDetails(
      agencyId,
      experienceId,
      reservationId,
    )
    const discount = await getCodeDiscount(
      agencyId,
      experienceId,
      reservationId,
      couponId,
    )
    if (!!discount) {
      if (
        moment(discount.expirationDate).format('YYYY-MM-DD HH:mm:ss') <
        moment().format('YYYY-MM-DD HH:mm:ss')
      ) {
        // setSnackOpen({
        //   isOpen: true,
        //   message: 'El código de descuento ya expiró, no puede ser utilizado',
        // })
        setIsExpirationCode(true)
        return
      }
      setCode(discount.code)

      setDetailDiscount(discount)
      const data = [
        createData('Fecha', formatDates(singleDate)),
        createData('Hora', time),
        createData('Catidad de huespedes', guestAmount),
        createData('Menores de Edad', childAmount),
        createData('Nombre', name),
        createData('Apellido', lastName),
        createData('Email', email),
        createData('Teléfono', `+${phone}`),
        createData('Precio en USD', `$${currencyExchanged}`),
        createData(
          'Adicional por persona',
          <CurrencyFormat
            value={addonsPersonsPrice}
            displayType="text"
            thousandSeparator
            prefix="$"
          />,
        ),
        createData(
          'Descuento',
          <>
            {discount.discount}% {'('}
            <CurrencyFormat
              value={
                ((totalPrice + addonsPersonsPrice) * discount.discount) / 100
              }
              displayType="text"
              thousandSeparator
              prefix="$"
            />
            {')'}
          </>,
        ),
      ]
      setIsDiscountApplied(true)
      setTermsAndConditions(true)
      setIsCharged(true)
      setDataToCode(data)
    } else {
      setIsError(true)
    }
  } // compartido ?? revisar

  const getAgency = async () => {
    const agencyResponse = await getAgencyById(agencyId)
    setPaypalClient(agencyResponse.clientId)
  }


  //SE CAMBIA ESTE USE EFFECT POR EL DE ABAJO

  useEffect(() => {
    changeCurrency(
      singleExperience.isPartialCharge &&
        singleExperience.partialPercentage !== 0
        ? partialPrice
        : totalPrice,
      'total',
    )
  }, [singleExperience.isPartialCharge, partialPrice, totalPrice, isDiscountApplied, singleExperience.partialPercentage])

  // SE AGREGAN isDiscountApplied, singleExperience.partialPercentage COMO DEPENDENCIAS


  useEffect(() => {
    if (!!reservationId && !!couponId) {
      // eslint-disable-next-line no-use-before-define

      fetchReservationData()
    }
    getExperienceResponse()
  }, [isCharged]) // revisar

  const createData = (title, data) => {
    return { title, data }
  } // compartida

  const rowsData = () => {
    // changeCurrency(
    //   singleExperience.isPartialCharge ? partialPrice : totalPrice,
    //   'total',
    // )

    let discount = 0
    /* 
        if (isDiscountApplied) {
          discount =
            (singleExperience.isPartialCharge
              ? partialPrice  
              : totalPrice * detailDiscount.discount) / 100
        } SE CAMBIA POR EL DE ABAJO */

    if (isDiscountApplied) {
      discount =
        (singleExperience.isPartialCharge
          ? Math.floor(partialPrice / 1000 * detailDiscount.discount)
          : totalPrice * detailDiscount.discount) / 100
    }

    let rows = []

    if (giftCard) {
      switch (type) {
        case 'HOTEL':
          rows = [
            createData('Fecha llegada', formatDates(startDate)),
            createData('Fecha salida', formatDates(endDate)),
            createData('Catidad de huespedes', guestAmount),
            createData('Menores de Edad', childAmount),
            createData('Nombre', name),
            createData('Apellido', lastName),
            createData('Email', email),
            createData('Teléfono', `+${phone}`),
            createData('Nombre del Obsequiado', giftedName),
            createData('Apellido del Obsequiado', giftedLastName),
            createData('Email del Obsequiado', giftedEmail),
            createData('Teléfono del Obsequiado', `+${giftedPhone}`),
            createData('Precio en USD', `$${currencyExchanged}`),
            createData(
              'Descuento',
              <CurrencyFormat
                value={discount}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Adicionales',
              <CurrencyFormat
                value={addonsPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Adicional por persona',
              <CurrencyFormat
                value={addonsPersonsPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Reserva',
              <CurrencyFormat
                value={reservationPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Total a pagar',
              <CurrencyFormat
                value={
                  singleExperience.isPartialCharge &&
                    singleExperience.partialPercentage !== 0
                    ? partialPrice
                    : singleExperience.isPartialCharge &&
                      singleExperience.partialPercentage === 0
                      ? totalPrice + addonsPersonsPrice
                      : totalPrice + addonsPersonsPrice
                }
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
          ]
          return rows
        case 'AGENCY':
          rows = [
            createData('Fecha', formatDates(singleDate)),
            createData('Hora', time),
            createData('Catidad de huespedes', guestAmount),
            createData('Menores de Edad', childAmount),
            createData('Nombre', name),
            createData('Apellido', lastName),
            createData('Email', email),
            createData('Teléfono', `+${phone}`),
            createData('Nombre del Obsequiado', giftedName),
            createData('Apellido del Obsequiado', giftedLastName),
            createData('Email del Obsequiado', giftedEmail),
            createData('Teléfono del Obsequiado', `+${giftedPhone}`),
            createData('Precio en USD', `$${currencyExchanged}`),
            createData(
              'Descuento',
              <CurrencyFormat
                value={discount}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Adicionales',
              <CurrencyFormat
                value={addonsPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Adicional por persona',
              <CurrencyFormat
                value={addonsPersonsPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Reserva',
              <CurrencyFormat
                value={reservationPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Total a pagar',
              <CurrencyFormat
                value={
                  singleExperience.isPartialCharge &&
                    singleExperience.partialPercentage !== 0
                    ? partialPrice
                    : singleExperience.isPartialCharge &&
                      singleExperience.partialPercentage === 0
                      ? totalPrice + addonsPersonsPrice
                      : totalPrice + addonsPersonsPrice
                }
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
          ]
          return rows

        case 'PROGRAM':
          rows = [
            createData('Fecha', formatDates(singleDate)),
            createData('Hora', time),
            createData('Catidad de huespedes', guestAmount),
            createData('Menores de Edad', childAmount),
            createData('Nombre', name),
            createData('Apellido', lastName),
            createData('Email', email),
            createData('Teléfono', `+${phone}`),
            createData('Nombre del Obsequiado', giftedName),
            createData('Apellido del Obsequiado', giftedLastName),
            createData('Email del Obsequiado', giftedEmail),
            createData('Teléfono del Obsequiado', `+${giftedPhone}`),
            createData('Precio en USD', `$${currencyExchanged}`),
            createData(
              'Descuento',
              <CurrencyFormat
                value={discount}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Adicionales',
              <CurrencyFormat
                value={addonsPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Adicional por persona',
              <CurrencyFormat
                value={addonsPersonsPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Reserva',
              <CurrencyFormat
                value={reservationPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Total a pagar',
              <CurrencyFormat
                value={
                  singleExperience.isPartialCharge &&
                    singleExperience.partialPercentage !== 0
                    ? partialPrice
                    : singleExperience.isPartialCharge &&
                      singleExperience.partialPercentage === 0
                      ? totalPrice + addonsPersonsPrice
                      : totalPrice + addonsPersonsPrice
                }
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
          ]
          return rows
        case 'TAILORMADE':
          rows = [
            createData('Fecha', formatDates(singleDate)),
            createData('Hora', time),
            createData('Catidad de huespedes', guestAmount),
            createData('Menores de Edad', childAmount),
            createData('Nombre', name),
            createData('Apellido', lastName),
            createData('Email', email),
            createData('Teléfono', `+${phone}`),
            createData('Nombre del Obsequiado', giftedName),
            createData('Apellido del Obsequiado', giftedLastName),
            createData('Email del Obsequiado', giftedEmail),
            createData('Teléfono del Obsequiado', `+${giftedPhone}`),
            createData('Precio en USD', `$${currencyExchanged}`),
            createData(
              'Descuento',
              <CurrencyFormat
                value={discount}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Adicionales',
              <CurrencyFormat
                value={addonsPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Adicional por persona',
              <CurrencyFormat
                value={addonsPersonsPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Reserva',
              <CurrencyFormat
                value={reservationPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Total a pagar',
              <CurrencyFormat
                value={
                  singleExperience.isPartialCharge &&
                    singleExperience.partialPercentage !== 0
                    ? partialPrice
                    : singleExperience.isPartialCharge &&
                      singleExperience.partialPercentage === 0
                      ? totalPrice + addonsPersonsPrice
                      : totalPrice + addonsPersonsPrice
                }
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
          ]
          return rows
        default:
          return 'Error al obtener la informacion'
      }
    } else {
      switch (type) {
        case 'HOTEL':
          rows = [
            createData('Fecha llegada', formatDates(startDate)),
            createData('Fecha salida', formatDates(endDate)),
            createData('Catidad de huespedes', guestAmount),
            createData('Menores de Edad', childAmount),
            createData('Nombre', name),
            createData('Apellido', lastName),
            createData('Email', email),
            createData('Teléfono', `+${phone}`),
            createData('Precio en USD', `$${currencyExchanged}`),
            createData(
              'Descuento',
              <CurrencyFormat
                value={discount}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Adicionales',
              <CurrencyFormat
                value={addonsPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Adicional por persona',
              <CurrencyFormat
                value={addonsPersonsPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Reserva',
              <CurrencyFormat
                value={reservationPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Total a pagar',
              <CurrencyFormat
                value={
                  singleExperience.isPartialCharge &&
                    singleExperience.partialPercentage !== 0
                    ? partialPrice
                    : singleExperience.isPartialCharge &&
                      singleExperience.partialPercentage === 0
                      ? totalPrice + addonsPersonsPrice
                      : totalPrice + addonsPersonsPrice
                }
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
          ]
          return rows
        case 'AGENCY':
          singleExperience.name === 'Motel'
            ? (rows = [
              singleExperience.isPartialCharge &&
                singleExperience.partialPercentage === 0 &&
                hotDeal
                ? createData('Fecha', formatDateDif)
                : createData('Fecha', formatDates(singleDate)),
              createData('Fecha salida', exitDate),
              createData('Hora', time),
              createData('Hora de salida', exitTime),
              createData('Catidad de huespedes', guestAmount),
              createData('Personas extra', extraPersons),
              createData('Menores de Edad', childAmount),
              createData('Nombre', name),
              createData('Apellido', lastName),
              createData('Email', email),
              createData('Teléfono', `+${phone}`),
              createData('Precio en USD', `$${currencyExchanged}`),
              createData(
                'Descuento',
                <CurrencyFormat
                  value={discount}
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                />,
              ),
              createData(
                'Adicionales',
                <CurrencyFormat
                  value={addonsPrice}
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                />,
              ),
              createData(
                'Adicional por persona',
                <CurrencyFormat
                  value={addonsPersonsPrice}
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                />,
              ),
              createData(
                'Reserva',
                <CurrencyFormat
                  value={reservationPrice}
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                />,
              ),
              createData(
                'Total a pagar',
                <CurrencyFormat
                  value={
                    singleExperience.isPartialCharge &&
                      singleExperience.partialPercentage !== 0
                      ? partialPrice
                      : singleExperience.isPartialCharge &&
                        singleExperience.partialPercentage === 0
                        ? totalPrice + addonsPersonsPrice
                        : totalPrice + addonsPersonsPrice
                  }
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                />,
              ),
            ])
            : (rows = [
              singleExperience.isPartialCharge &&
                singleExperience.partialPercentage === 0 &&
                hotDeal
                ? createData('Fecha', formatDateDif)
                : createData('Fecha', formatDates(singleDate)),
              createData('Hora', time),
              createData('Catidad de huespedes', guestAmount),
              createData('Menores de Edad', childAmount),
              createData('Nombre', name),
              createData('Apellido', lastName),
              createData('Email', email),
              createData('Teléfono', `+${phone}`),
              createData('Precio en USD', `$${currencyExchanged}`),
              createData(
                'Descuento',
                <CurrencyFormat
                  value={discount}
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                />,
              ),
              createData(
                'Adicionales',
                <CurrencyFormat
                  value={addonsPrice}
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                />,
              ),
              createData(
                'Adicional por persona',
                <CurrencyFormat
                  value={addonsPersonsPrice}
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                />,
              ),
              createData(
                'Reserva',
                <CurrencyFormat
                  value={reservationPrice}
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                />,
              ),
              createData(
                'Total a pagar',
                <CurrencyFormat
                  value={
                    singleExperience.isPartialCharge &&
                      singleExperience.partialPercentage !== 0
                      ? partialPrice
                      : singleExperience.isPartialCharge &&
                        singleExperience.partialPercentage === 0
                        ? totalPrice + addonsPersonsPrice
                        : totalPrice + addonsPersonsPrice
                  }
                  displayType="text"
                  thousandSeparator
                  prefix="$"
                />,
              ),
            ])
          return rows
        case 'PROGRAM':
          rows = [
            createData('Fecha', formatDates(singleDate)),
            createData('Hora', time),
            createData('Catidad de huespedes', guestAmount),
            createData('Menores de Edad', childAmount),
            createData('Nombre', name),
            createData('Apellido', lastName),
            createData('Email', email),
            createData('Teléfono', `+${phone}`),
            createData('Precio en USD', `$${currencyExchanged}`),
            createData(
              'Descuento',
              <CurrencyFormat
                value={discount}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Adicionales',
              <CurrencyFormat
                value={addonsPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Adicional por persona',
              <CurrencyFormat
                value={addonsPersonsPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Reserva',
              <CurrencyFormat
                value={reservationPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Total a pagar',
              <CurrencyFormat
                value={
                  singleExperience.isPartialCharge &&
                    singleExperience.partialPercentage !== 0
                    ? partialPrice
                    : singleExperience.isPartialCharge &&
                      singleExperience.partialPercentage === 0
                      ? totalPrice + addonsPersonsPrice
                      : totalPrice + addonsPersonsPrice
                }
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
          ]
          return rows
        case 'TAILORMADE':
          rows = [
            createData('Fecha', formatDates(singleDate)),
            createData('Hora', time),
            createData('Catidad de huespedes', guestAmount),
            createData('Menores de Edad', childAmount),
            createData('Nombre', name),
            createData('Apellido', lastName),
            createData('Email', email),
            createData('Teléfono', `+${phone}`),
            createData('Precio en USD', `$${currencyExchanged}`),
            createData(
              'Descuento',
              <CurrencyFormat
                value={discount}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Adicionales',
              <CurrencyFormat
                value={addonsPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Adicional por persona',
              <CurrencyFormat
                value={addonsPersonsPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Reserva',
              <CurrencyFormat
                value={reservationPrice}
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
            createData(
              'Total a pagar',
              <CurrencyFormat
                value={
                  singleExperience.isPartialCharge &&
                    singleExperience.partialPercentage !== 0
                    ? partialPrice
                    : singleExperience.isPartialCharge &&
                      singleExperience.partialPercentage === 0
                      ? totalPrice + addonsPersonsPrice
                      : totalPrice + addonsPersonsPrice
                }
                displayType="text"
                thousandSeparator
                prefix="$"
              />,
            ),
          ]
          return rows
        default:
          return 'Error al obtener la informacion'
      }
    }
  } // compartido ?? revisar
  const validateTerms = () => {
    if (termsAndConditions) {
      setTermsAccepted(true)
      return true
    } else {
      setTermsAccepted(false)
      return false
    }
  } // compartido

  const validateCode = async (query) => {
    query.preventDefault()
    clearTimeout(filterTimeout)

    filterTimeout = setTimeout(async () => {
      const code = query.target.value

      if (code === '' || code === undefined) {
        setIsError(false)
        return
      }
      await validationCoupon(agency.key, singleExperience.key, code).then(
        (r) => {
          const filter = r.filter((cou) => {
            if (Array.isArray(cou.experience) && cou.code === code) {
              return cou.experience.some(
                (exp) => exp.split('|')[0] === singleExperience.key,
              )
            } else {
              // Si cou.experience es un string, aplicamos la lógica original
              return (
                (cou.code === code &&
                  cou.experience.split('|')[0] === singleExperience.key) ||
                (cou.code === code && cou.experience === 'any')
              )
            }
          })

          if (filter.length > 0) {
            setIsError(false)
            const now = moment().format('YYYY-MM-DD HH:mm:ss')
            const day =
              type === 'HOTEL'
                ? moment(formatDateToDB(startDate)).day()
                : moment(formatDateToDB(singleDate)).day()
            const checkday = filter[0].days.filter((d, index) =>
              day === 0 ? index === 6 : index === day - 1,
            )
            debugger
            if (checkday[0].checked) {
              if (
                now >
                moment(filter[0].expirationDate).format('YYYY-MM-DD HH:mm:ss')
              ) {
                setIsExpirationCode(true)
                setIsError(false)
                return
              }
              setIsDiscountApplied(true)
              setOpenSnackBarCodes(true)
              setIsError(false)
              setIsErrorDay(false)
              setDetailDiscount(filter[0])
            } else {
              setIsErrorDay(true)
              setOpenSnackBarCodes(true)
              setDetailDiscount({ discount: 0 })
            }
          } else {
            setIsError(true)
            setOpenSnackBarCodes(true)
            setDetailDiscount({ discount: 0 })
          }
        },
      )
    }, 500)
  } // compartida ?? revisar

  function changeCurrency(amount) {
    const apiKey = `${process.env.REACT_APP_API_KEY_CURRENCY}`
    const url = 'https://api.api-ninjas.com/v1/convertcurrency'
    const params = {
      want: 'USD',
      have: 'CLP',
      amount: amount,
    }

    axios({
      method: 'get',
      url: url,
      params: params,
      headers: {
        'X-Api-Key': apiKey,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        let tipoDeCambio = response.data.old_amount / response.data.new_amount
        setClpToUsd(tipoDeCambio.toFixed(3))
        let currency = response.data.new_amount
        currency += (currency * 5.4) / 100 // se le suma comision de paypal por uso de servicio
        currency += 0.3 // por paypal y usp de servicio
        currency += (currency * 1) / 100 // sumo el 1% para protegernos por perdidas por fluctuacion de tipo de cambio
        currency = currency.toFixed(2)
        setCurrencyExchanged(currency)
      })
      .catch((error) => {
        console.error('Error:', error.response.data)
      })
  } // de aca saco currencyExchanged y clpToUsd

  async function getExperienceResponse() {
    const experienceR = await getExperienceById(experienceId)
    setExperienceResponse(experienceR)
    return
  } // de aca saco experienceResponse

  const reservationDetail = [
    {
      key: 'detailTab',
      label: 'Detalle de la Reserva',
      children: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {!!reservationId && !!couponId
            ? dataToCode.map((row) => (
              <div
                key={row.title}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div style={{ flexBasis: '60%' }}>
                  {/* Aumentamos el espacio para el título */}
                  <p style={{ fontWeight: 'bold' }}>{row.title}</p>
                </div>
                <div style={{ flexBasis: '40%', textAlign: 'right' }}>
                  {/* Espacio para el dato con alineación a la derecha */}
                  <p>{row.data}</p>
                </div>
              </div>
            ))
            : rowsData().map((row) => (
              <div
                key={row.title}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div style={{ flexBasis: '60%' }}>
                  {/* Aumentamos el espacio para el título */}
                  <p
                    style={{
                      fontWeight: 'bold',
                      fontFamily: "'Muli', sans-serif",
                    }}
                  >
                    {row.title}
                  </p>
                </div>
                <div style={{ flexBasis: '40%', textAlign: 'right' }}>
                  {/* Espacio para el dato con alineación a la derecha */}
                  <p
                    style={{
                      fontFamily: "'Muli', sans-serif",
                    }}
                  >
                    {row.data}
                  </p>
                </div>
              </div>
            ))}
          {isDiscountApplied && (
            <>
              {' '}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div style={{ flexBasis: '60%' }}>
                  {/* Aumentamos el espacio para el título */}
                  <p style={{ fontWeight: 'bold' }}>Descuento en USD</p>
                </div>
                <div style={{ flexBasis: '40%', textAlign: 'right' }}>
                  {/* Espacio para el dato con alineación a la derecha */}
                  <p>
                    Antes{' '}
                    <CurrencyFormat
                      value={currencyExchanged}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      style={{ textDecoration: 'line-through' }}
                    />
                  </p>
                  <p>
                    Ahora{' '}
                    <CurrencyFormat
                      value={(
                        currencyExchanged -
                        (currencyExchanged * detailDiscount.discount) / 100
                      ).toFixed(2)}
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      style={{ fontWeight: 'bold' }}
                    />
                  </p>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div style={{ flexBasis: '60%' }}>
                  {/* Aumentamos el espacio para el título */}
                  <p style={{ fontWeight: 'bold' }}>Descuento</p>
                </div>
                <div style={{ flexBasis: '40%', textAlign: 'right' }}>
                  {/* Espacio para el dato con alineación a la derecha */}
                  <p>
                    Antes{' '}
                    <CurrencyFormat
                      value={
                        singleExperience.isPartialCharge
                          ? partialPrice + addonsPersonsPrice
                          : totalPrice + addonsPersonsPrice
                      }
                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      style={{ textDecoration: 'line-through' }}
                    />
                  </p>
                  <p>
                    {/*singleExperience.isPartialCharge
                          ? partialPrice
                          : totalPrice +
                          addonsPersonsPrice -
                          (singleExperience.isPartialCharge
                            ? partialPrice
                            : (totalPrice + addonsPersonsPrice) *
                            detailDiscount.discount) /
                          100  ESTE ES EL OTRO CAMBIO HECHO*/}
                    Ahora{' '}
                    {/* TODO ARREGLAR EN TOTAL CUANDO NO ES EXPERIENCIA SINGLE, SOLO TOTAL CON DESCUENTO Y SIN DESCUENTO*/}
                    <CurrencyFormat

                      value={
                        singleExperience.isPartialCharge && isDiscountApplied
                          ? Math.floor((partialPrice + addonsPersonsPrice) * ((100 - detailDiscount.discount) / 100)) //partialPrice
                          : singleExperience.isPartialCharge
                            ? partialPrice
                            : totalPrice +
                            addonsPersonsPrice -
                            (singleExperience.isPartialCharge
                              ? partialPrice
                              : (totalPrice + addonsPersonsPrice) *
                              detailDiscount.discount) /
                            100

                      }

                      displayType="text"
                      thousandSeparator
                      prefix="$"
                      style={{ fontWeight: 'bold' }}
                    />
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
      ),
    },
  ]

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Col
        span={24}
        style={{
          marginTop: '5%',
        }}
      >
        <Collapse
          size="small"
          items={reservationDetail}
          expandIconPosition="end"
          style={{ margin: 'auto' }}
        ></Collapse>
      </Col>
      {!termsAndConditions && (
        <Grid item xs={12} style={{ marginTop: '4%' }}>
          <Alert severity="warning">
            Para continuar complete los Datos y acepte los Términos y
            condiciones{' '}
          </Alert>
        </Grid>
      )}{' '}
      <Row
        item
        xs={24}
        style={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Col
          span={24}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            marginTop: '5px',
          }}
        >
          <span
            style={{
              fontWeight: '600',
              verticalAlign: 'middle',
              fontFamily: "'Quicksand', sans-serif",
              padding: '5px',
              marginTop: '2%',
            }}
          >
            ¿Tienes un código de descuento?
          </span>
          <div style={{ width: '100%', padding: '5px', marginTop: '2%' }}>
            <Input
              required
              value={code}
              placeholder="Ingresa tu código de descuento"
              onChange={(e, value) => {
                setCode(value)
                validateCode(e)
              }}
              InputProps={{
                readOnly: !!reservationId && !!couponId,
              }}
              fullWidth // Use el atributo fullWidth en lugar de width: '100%'
            />
          </div>
        </Col>
      </Row>
      {/* CODIGO DE DESCUENTO */}
      <Row gutter={24}>
        <Row
          span={24}
          style={{ marginTop: '7%', marginLeft: 'auto', marginRight: 'auto' }}
        >
          <Col
            span={24}
            style={{
              fontFamily: "'Muli', sans-serif",
            }}
          >
            <Checkbox
              checked={termsAndConditions}
              onChange={() => {
                if (giftCard === true) {
                  if (
                    !isErrorName &&
                    !isErrorLastName &&
                    !isErrorEmail &&
                    !isErrorGiftedName &&
                    !isErrorGiftedLastName &&
                    !isErrorGiftedEmail
                  ) {
                    setAlertTermsAndConditions(false)
                    setOpenSnackBarTerms(false)
                    setTermsAndConditions(!termsAndConditions)
                  } else {
                    setAlertTermsAndConditions(true)
                    setOpenSnackBarTerms(true)
                  }
                } else if (
                  !isErrorName &&
                  !isErrorLastName &&
                  !isErrorEmail &&
                  phone
                ) {
                  setAlertTermsAndConditions(false)
                  setOpenSnackBarTerms(false)
                  setTermsAndConditions(!termsAndConditions)
                } else {
                  setAlertTermsAndConditions(true)
                  setOpenSnackBarTerms(true)
                }
              }}
            />
            <span>
              Aceptar{' '}
              <Link to={`/terms-and-conditions/${agency.key}`} target="_blank">
                Términos y condiciones
              </Link>{' '}
              para pagar
            </span>
          </Col>
        </Row>
      </Row>
      {alertTermsAndConditions && (
        <Snackbar
          open={openSnackBarTerms}
          autoHideDuration={6000}
          onClose={() => setOpenSnackBarTerms(false)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert onClose={() => setOpenSnackBarTerms(false)} severity="error">
            Por favor verifique los datos ingresados
          </Alert>
        </Snackbar>
      )}
      {isError && (
        <Snackbar
          open={openSnackBarCodes}
          autoHideDuration={3000}
          onClose={() => {
            setOpenSnackBarCodes(false)
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Grid item xs={12}>
            <Alert
              sx={{ width: '100%' }}
              severity="error"
              onClose={() => {
                isError(false)
                setOpenSnackBarCodes(false)
              }}
            >
              El código de descuento no existe en nuestros registros
            </Alert>
          </Grid>
        </Snackbar>
      )}
      {isErrorDay && (
        <Snackbar
          open={openSnackBarCodes}
          autoHideDuration={3000}
          onClose={() => {
            setOpenSnackBarCodes(false)
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Grid item xs={12}>
            <Alert
              sx={{ width: '100%' }}
              severity="error"
              onClose={() => {
                isErrorDay(false)
                setOpenSnackBarCodes(false)
              }}
            >
              El código de descuento no es aplicable el día seleccionado
            </Alert>
          </Grid>
        </Snackbar>
      )}
      {isExpirationCode && (
        <Snackbar
          open={openSnackBarCodes}
          autoHideDuration={3000}
          onClose={() => {
            setOpenSnackBarCodes(false)
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Grid item xs={12}>
            <Alert
              sx={{ width: '100%' }}
              severity="error"
              onClose={() => {
                setIsExpirationCode(false)
                setOpenSnackBarCodes(false)
              }}
            >
              El código de descuento ya expiró, no puede ser utilizado
            </Alert>
          </Grid>
        </Snackbar>
      )}
      {isDiscountApplied === true ? (
        <Snackbar
          open={openSnackBarCodes}
          autoHideDuration={5000}
          onClose={() => {
            setOpenSnackBarCodes(false)
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Grid item xs={12}>
            <Alert
              sx={{ width: '100%' }}
              severity="success"
              onClose={() => {
                //setIsDiscountApplied(false)
                setOpenSnackBarCodes(false)
              }}
            >
              Código de descuento aplicado, revise el detalle de la Reserva
            </Alert>
          </Grid>
        </Snackbar>
      ) : null}
      {/* FIN CODIGO DE DESCUENTO */}
      {/* {termsAccepted && (
        <Grid item xs={12}>
          <Alert severity="error">
            Para continuar complete los Datos y acepte los Términos y
            condiciones{' '}
          </Alert>
        </Grid>
      )} */}
      {termsAndConditions === true ? (
        <Row gutter={16}>
          <div
            id="payment"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: '100%',
              marginTop: '5px',
            }}
          >
            <b>Seleccione método de pago</b>
            {singleExperience.isPartialCharge &&
              singleExperience.partialPercentage === 0 &&
              !hotDeal ? (
              <Grid xs={12} md={12}>
                <DifPay
                  currencyExchanged={currencyExchanged}
                  experienceResponse={experienceResponse}
                  agencyId={agencyId ? agencyId : agency.key}
                  experienceId={experienceId}
                  isDiscountApplied={isDiscountApplied}
                  detailDiscount={detailDiscount}
                  isError={isError}
                  isExpirationCode={isExpirationCode}
                  isErrorDay={isErrorDay}
                  validateTerms={() => validateTerms() && validPayMentDates()}
                  clpToUsd={clpToUsd}
                />
              </Grid>
            ) : (
              <Grid item xs={12} md={12} style={{ width: '90%' }}>
                {agency.paymentMethodFlow === true &&
                  agency.paymentMethodPayPal === true &&
                  paypalClient !== null &&
                  paypalClient !== undefined &&
                  paypalClient !== '' ? (
                  <>
                    <Grid xs={12} md={12} style={{ width: '100%' }}>
                      <PayPalModule
                        hotDeal={
                          singleExperience.isPartialCharge &&
                            singleExperience.partialPercentage === 0 &&
                            hotDeal
                            ? hotDeal
                            : null
                        }
                        formatDateDif={
                          singleExperience.isPartialCharge &&
                            singleExperience.partialPercentage === 0 &&
                            hotDeal
                            ? dateDealDif
                            : null
                        }
                        currencyExchanged={currencyExchanged}
                        experienceResponse={experienceResponse}
                        agencyId={agencyId ? agencyId : agency.key}
                        experienceId={experienceId}
                        isDiscountApplied={isDiscountApplied}
                        detailDiscount={detailDiscount}
                        isError={isError}
                        isExpirationCode={isExpirationCode}
                        isErrorDay={isErrorDay}
                        validateTerms={() =>
                          validateTerms() && validPayMentDates()
                        }
                        clpToUsd={clpToUsd}
                        paypalClient={paypalClient}
                      />
                    </Grid>
                    <Grid md={12} style={{ marginTop: '10px', width: '100%' }}>
                      <FlowModule
                        hotDeal={
                          singleExperience.isPartialCharge &&
                            singleExperience.partialPercentage === 0 &&
                            hotDeal
                            ? hotDeal
                            : null
                        }
                        formatDateDif={
                          singleExperience.isPartialCharge &&
                            singleExperience.partialPercentage === 0 &&
                            hotDeal
                            ? dateDealDif
                            : null
                        }
                        experienceResponse={experienceResponse}
                        agencyId={agencyId ? agencyId : agency.key}
                        experienceId={experienceId}
                        isDiscountApplied={isDiscountApplied}
                        detailDiscount={detailDiscount}
                        isError={isError}
                        isExpirationCode={isExpirationCode}
                        isErrorDay={isErrorDay}
                        validateTerms={() =>
                          validateTerms() && validPayMentDates()
                        }
                      />
                    </Grid>
                  </>
                ) : agency.paymentMethodFlow === false &&
                  agency.paymentMethodPayPal === true &&
                  paypalClient !== null &&
                  paypalClient !== undefined &&
                  paypalClient !== '' ? (
                  <Grid xs={12} md={12} style={{ width: '100%' }}>
                    <PayPalModule
                      hotDeal={
                        singleExperience.isPartialCharge &&
                          singleExperience.partialPercentage === 0 &&
                          hotDeal
                          ? hotDeal
                          : null
                      }
                      formatDateDif={
                        singleExperience.isPartialCharge &&
                          singleExperience.partialPercentage === 0 &&
                          hotDeal
                          ? dateDealDif
                          : null
                      }
                      currencyExchanged={currencyExchanged}
                      experienceResponse={experienceResponse}
                      agencyId={agencyId ? agencyId : agency.key}
                      experienceId={experienceId}
                      isDiscountApplied={isDiscountApplied}
                      detailDiscount={detailDiscount}
                      isError={isError}
                      isExpirationCode={isExpirationCode}
                      isErrorDay={isErrorDay}
                      validateTerms={() =>
                        validateTerms() && validPayMentDates()
                      }
                      clpToUsd={clpToUsd}
                      paypalClient={paypalClient}
                    />
                  </Grid>
                ) : agency.paymentMethodFlow === true ? (
                  <Grid xs={12} md={12} style={{ width: '100%' }}>
                    <FlowModule
                      hotDeal={
                        singleExperience.isPartialCharge &&
                          singleExperience.partialPercentage === 0 &&
                          hotDeal
                          ? hotDeal
                          : null
                      }
                      formatDateDif={
                        singleExperience.isPartialCharge &&
                          singleExperience.partialPercentage === 0 &&
                          hotDeal
                          ? dateDealDif
                          : null
                      }
                      experienceResponse={experienceResponse}
                      agencyId={agencyId ? agencyId : agency.key}
                      experienceId={experienceId}
                      isDiscountApplied={isDiscountApplied}
                      detailDiscount={detailDiscount}
                      isError={isError}
                      isExpirationCode={isExpirationCode}
                      isErrorDay={isErrorDay}
                      validateTerms={() =>
                        validateTerms() && validPayMentDates()
                      }
                    />
                  </Grid>
                ) : null}
              </Grid>
            )}
          </div>
        </Row>
      ) : null}
    </Space>
  )
}

export default VerifyDetails
